export function calculatePutReturnToExpiry(strikePrice: number, mid: number, expirationDate: Date, riskFreeRate: number) {
    const today = new Date();
    const diffInMilliseconds = expirationDate.getTime() - today.getTime();
    const days = diffInMilliseconds / (1000 * 60 * 60 * 24);
    const interestEarned = strikePrice * Math.pow(1 + riskFreeRate, days / 365) - strikePrice;
    return Math.exp(Math.log((strikePrice + interestEarned) / (strikePrice - mid)) / (days / 365)) - 1;
}
